module.exports = __webpack_public_path__ + "static/media/Acquire Shared Coordinates Notification.34620b55.png";